import Vue from 'vue'
import App from './App.vue'
import './plugins/axios'
import i18n from './i18n.js'
import router from './router'
import 'vuetify/dist/vuetify.min.css'
import vuetify from './plugins/vuetify';
//import VeeValidate from 'vee-validate'

import mxComunication from './mixins/mx-Comunication.vue';
import mxGlobal from './mixins/mxGlobal.vue';

Vue.config.productionTip = false

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

// Vue.use(VeeValidate, {
//   delay: 100,
//   locale: 'es',
//   strict: true,
//   inject: true,
// })

Vue.mixin({
  mixins: [mxComunication, mxGlobal],
  data () {
    return {
    }
  }
})

new Vue({
  vuetify,
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')

export default EventBus
